import { render, staticRenderFns } from "./potentialApplicants.vue?vue&type=template&id=1c8553c9&"
import script from "./potentialApplicants.vue?vue&type=script&lang=js&"
export * from "./potentialApplicants.vue?vue&type=script&lang=js&"
import style0 from "./potentialApplicants.vue?vue&type=style&index=0&id=1c8553c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports